import React from 'react';
import BibleVerse from '../utils/BibleVerse';

function WhatWeBelieveMore(props) {
  return (
    <div>
      <h3>Salvation</h3>
      <ol type="1">
        <li>Salvation is wholly of God by grace through faith on the basis of the redemption by Christ Jesus, the merit of His shed blood, and not on the basis of human merit or works.</li>
        <li>Salvation is an all-inclusive term from the special calling of God to justification by faith, to regeneration and sanctification through the Holy Spirit, to ultimate glorification in the presence of God.</li>
        <li>Believers have two natures, namely the flesh and the spirit. The believer is to grow in grace and in the knowledge of Christ, and to strive to live a life of holiness characterized by love for God and for his neighbours.</li>
        <li>If the believer is truly regenerated or “born again,” he has eternal security through the election and grace of God.</li>
      </ol>
      <p>
        <BibleVerse reference="JHN.1.12" text="John 1:12" />
        <BibleVerse reference="JHN.3.16-18" text="John 3:16-18" />
        <BibleVerse reference="JHN.3.36" text="John 3:36" />
        <BibleVerse reference="JHN.14.6" text="John 14:6" />
        <BibleVerse reference="ACT.4.11-12" text="Acts 4:11-12" />
        <BibleVerse reference="ROM.3.21-30" text="Romans 3:21-30" />
        <BibleVerse reference="ROM.8.30-39" text="Romans 8:30-39" />
        <BibleVerse reference="ROM.10.9-13" text="Romans 10:9-13" />
        <BibleVerse reference="2CO.5.21" text="2 Corinthians 5:21" />
        <BibleVerse reference="EPH.1.7" text="Ephesians 1:7" />
        <BibleVerse reference="EPH.2.8-10" text="Ephesians 2:8-10" />
        <BibleVerse reference="1TH.4.3" text="1 Thessalonians 4:3" />
        <BibleVerse reference="1PE.1.18-19" text="1 Peter 1:18-19" />
      </p>
      <h3>Satan</h3>
      <p>We believe in the existence of Satan as a supernatural being, the deceiver and prince of this world. He was defeated and judged by the death and resurrection of the Lord Jesus Christ, and therefore his final doom is certain.</p>
      <p><em>
        <BibleVerse reference="GEN.3.1-6" text="Genesis 3:1-6" />
        <BibleVerse reference="ISA.14.12-15" text="Isaiah 14:12-15" />
        <BibleVerse reference="EZK.28.11-19" text="Ezekiel 28:11-19" />
        <BibleVerse reference="MAT.4.1-11" text="Matthew 4:1-11" />
        <BibleVerse reference="MAT.25.41" text="Matthew 25:41" />
        <BibleVerse reference="JHN.8.44" text="John 8:44" />
        <BibleVerse reference="JHN.14.30" text="John 14:30" />
        <BibleVerse reference="JHN.16.5-11" text="John 16:5-11" />
        <BibleVerse reference="2CO.4.4" text="2 Corinthians 4:4" />
        <BibleVerse reference="EPH.2.1-2" text="Ephesians 2:1-2" />
        <BibleVerse reference="HEB.2.14-15" text="Hebrews 2:14-15" />
        <BibleVerse reference="1PE.5.8" text="1 Peter 5:8" />
        <BibleVerse reference="1JN.3.8" text="1 John 3:8" />
        <BibleVerse reference="1JN.5.19" text="1 John 5:19" />
        <BibleVerse reference="REV.12.7-12" text="Revelation 12:7-12" />
        <BibleVerse reference="REV.20.1-3" text="Revelation 20:1-3" />
        <BibleVerse reference="REV.20.10" text="Revelation 20:10" />
      </em></p>
      <h3>The Church</h3>
      <ol type="1">
        <li>
          All who place their faith in the Lord Jesus Christ are immediately placed by the Holy Spirit into one united spiritual body, the Church, the Bride of Christ, of which He is the Head.
          <br />
          <em>
            <BibleVerse reference="ACT.2.38" text="Acts 2:38" />
            <BibleVerse reference="ACT.11.15" text="Acts 11.15" />
            <BibleVerse reference="EPH.1.13-14" text="Ephesians 1:13-14" />
            <BibleVerse reference="EPH.1.22" text="Ephesians 1:22" />
            <BibleVerse reference="EPH.4.4-6" text="Ephesians 4:4-6" />
            <BibleVerse reference="EPH.5.23" text="Ephesians 5:23" />
            <BibleVerse reference="1CO.12.13" text="1 Corinthians 12:13" />
          </em>
        </li>
        <li>
          The formation of the church, the body of Christ, began on the day of Pentecost and will be completed at the coming of Christ for His own at the rapture.
          <br />
          <em>
            <BibleVerse reference="ACT.2.1-47" text="Acts 2:1-47" />
            <BibleVerse reference="ACT.9.31" text="Acts 9:31" />
            <BibleVerse reference="1CO.15.21-23" text="1 Corinthians 15:21-23" />
            <BibleVerse reference="1TH.4.13-18" text="1 Thessalonians 4:13-18" />
          </em>
        </li>
        <li>
          The establishment and continuity of local churches is clearly taught and defined in the New Testament, and the members of the one spiritual body, also known as the universal church, are directed to associate themselves together in a local church or assembly.
          <br />
          <em>
            <BibleVerse reference="ROM.16.3-5" text="Romans 16:3-5" />
            <BibleVerse reference="1CO.1.2-3" text="1 Corinthians 1:2-3" />
            <BibleVerse reference="1CO.16.19" text="1 Corinthians 16:19" />
            <BibleVerse reference="COL.4.15" text="Colossians 4:15" />
            <BibleVerse reference="PHM.1.2-3" text="Philemon 1:2-3" />
            <BibleVerse reference="GAL.1.2" text="Galatians 1:2" />
            <BibleVerse reference="1TH.1.1" text="1 Thessalonians 1:1" />
            <BibleVerse reference="REV.1" text="Revelation 1-3" />
            <BibleVerse reference="EPH.4.4-6" text="Ephesians 4:4-6" />
            <BibleVerse reference="EPH.5.22-32" text="Ephesians 5:22-32" />
            <BibleVerse reference="HEB.10.24-25" text="Hebrews 10:24-25" />
          </em>
        </li>
        <li>
          There are two offices for the church, elders and deacons. They are to lead or rule as servants and to have Christ's authority in directing the church, the congregation which are to submit themselves to their leadership.
          <br />
          <em>
            <BibleVerse reference="ACT.20.17-28" text="Acts 20:17-28" />
            <BibleVerse reference="1CO.14.40" text="1 Corinthians 14:40" />
            <BibleVerse reference="PHP.1.1" text="Philippians 1:1" />
            <BibleVerse reference="1TI.3.1-13" text="1 Timothy 3:1-13" />
            <BibleVerse reference="1TH.5.12-13" text="1 Thessalonians 5:12-13" />
            <BibleVerse reference="TIT.1.5-16" text="Titus 1:5-16" />
            <BibleVerse reference="HEB.13.17" text="Hebrews 13:17" />
            <BibleVerse reference="1PE.5.1-5" text="1 Peter 5:1-5" />
          </em>
        </li>
        <li>
          The Scriptures stress discipleship within the context of the local Church and the mutual submission of all believers fellowshipping therein to each other.
          <br />
          <em>
            <BibleVerse reference="EPH.4.11-16" text="Ephesians 4:11-16" />
            <BibleVerse reference="EPH.5.21" text="Ephesians 5:21" />
            <BibleVerse reference="1TH.5.12-15" text="1 Thessalonians 5:12-15" />
            <BibleVerse reference="HEB.13.17" text="Hebrews 13:17" />
          </em>
        </li>
        <li>
          Discipline of sinning members of the local church is to be administered in accordance with the Scriptures.
          <br />
          <em>
            <BibleVerse reference="MAT.18.15-20" text="Matthew 18:15-20" />
            <BibleVerse reference="LUK.17.3-4" text="Luke 17:3-4" />
            <BibleVerse reference="1CO.5.4-5" text="1 Corinthians 5:4-5" />
            <BibleVerse reference="GAL.6.1" text="Galatians 6:1" />
            <BibleVerse reference="1TI.5.19-21" text="1 Timothy 5:19-21" />
            <BibleVerse reference="2TH.3.6" text="2 Thessalonians 3:6" />
          </em>
        </li>
        <li>The purpose of the Church is to glorify God by the following: <br />
          <ol type="a">
            <li> Corporate worship</li>
            <li> Building herself up in the faith</li>
            <li> Instruction of the Word</li>
            <li> Fellowship</li>
            <li> Keeping the ordinances of the Church</li>
            <li> Advancing and communicating the Gospel to the entire world</li>
            <li> Prayer</li>
          </ol>
          <em>
            <BibleVerse reference="MAT.22.37-39" text="Matthew 22:37-39" />
            <BibleVerse reference="MAT.28.18-20" text="Matthew 28:18-20" />
            <BibleVerse reference="MRK.16.15-16" text="Mark 16:15-16" />
            <BibleVerse reference="LUK.24.45-48" text="Luke 24:45-48" />
            <BibleVerse reference="JHN.20.21" text="John 20:21" />
            <BibleVerse reference="ACT.1.8" text="Acts 1:8" />
            <BibleVerse reference="ACT.2.41-47" text="Acts 2:41-47" />
            <BibleVerse reference="ACT.8.12" text="Acts 8:12" />
            <BibleVerse reference="ACT.8.36" text="Acts 8:36-39" />
            <BibleVerse reference="1CO.11.23-26" text="1 Corinthians 11:23-26" />
            <BibleVerse reference="EPH.4.11-16" text="Ephesians 4:11-16" />
          </em>
        </li>
        <li>The ordinances of the local church which were instituted by Jesus Christ are two
            in number and are as follows:<br />
          <ol type="a">
            <li>Believer&#39;s Baptism by immersion, which is a public identification of the
            believer with Jesus Christ in his death, burial and resurrection. It is a visual
            indication of personal faith in the person and work of Christ for salvation and
            has no sacramental value in imparting salvation.
              <br />
              <em>
                <BibleVerse reference="MAT.3.16" text="Matthew 3:16" />
                <BibleVerse reference="MAT.28.19" text="Matthew 28:19" />
                <BibleVerse reference="JHN.3.23" text="John 3:23" />
                <BibleVerse reference="ACT.8.26-36" text="Acts 8:26-39" />
                <BibleVerse reference="ROM.6.3-5" text="Romans 6:3-5" />
                <BibleVerse reference="COL.2.12" text="Colossians 2:12" />
              </em>
            </li>
            <li>The Lord&#39;s Supper, in which all believers in the Lord Jesus Christ are invited
            to participate, with due regard to the Scriptural warnings in 1 Corinthians
            11:27-29. It is purely a time of remembering the death, burial, and resurrection
            of the Lord Jesus Christ and has no sacramental value in imparting salvation.
              <br />
              <em>
                <BibleVerse reference="MAT.26.26-30" text="Matthew 26:26-30" />
                <BibleVerse reference="MRK.14.22-26" text="Mark 14:22-26" />
                <BibleVerse reference="LUK.22.14-20" text="Luke 22:14-20" />
                <BibleVerse reference="1CO.11.23-28" text="1 Corinthians 11:23-28" />
              </em>
            </li>
          </ol>
        </li>
      </ol>
      <h3>Separation</h3>
      <p>We believe that the Scriptures require separation unto God from the world and
      from apostasy within the visible Church. This doctrine is based upon God&#39;s
      eternal principle of division between truth and error, darkness and light, and His
      specific command to be separated from the ungodliness of the world, and from
disobedient brethren.</p>
      <p><em>
        <BibleVerse reference="2CO.6.14-17" text="2 Corinthians 6:14-17" />
        <BibleVerse reference="2TH.3.6" text="2 Thessalonians 3:6" />
        <BibleVerse reference="1TI.6.3-5" text="1 Timothy 6:3-5" />
        <BibleVerse reference="JAS.4.4" text="James 4:4" />
        <BibleVerse reference="1JN.2.15-16" text="1 John 2:15-16" />
        <BibleVerse reference="2JN.1.9-11" text="2 John 1:9-11" />
      </em></p>
      <h3>Last Things</h3>
      <ol type="1">
        <li>We believe in the resurrection of the body and the judgement of the world by the Lord Jesus Christ, with eternal blessedness for the righteous and eternal punishment for the wicked.
          <p><em>
            <BibleVerse reference="MAT.25.32-34" text="Matthew 25:32-34" />
            <BibleVerse reference="MAT.25.46" text="Matthew 25:46" />
            <BibleVerse reference="1CO.15.12-28" text="1 Corinthians 15:12-28" />
            <BibleVerse reference="REV.20.5-6" text="Revelation 20:5-6" />
            <BibleVerse reference="REV.20.12-15" text="Revelation 20:12-15" />
          and </em></p>
        </li>
        <li>We believe in the imminent return of the Lord Jesus Christ.
          <br />
          <em>
            <BibleVerse reference="PHP.4.4-6" text="Philippians 4:4-6" />
            <BibleVerse reference="JAS.5.8-9" text="James 5:8-9" />
            <BibleVerse reference="REV.22.12" text="Revelation 22:12" />
          </em>
          <ol type="a">
            <li>Believers will be caught up to meet the Lord in the air prior to the seven-year tribulation.
              <br />
              <em>
                <BibleVerse reference="JHN.14.1-3" text="John 14:1-3" />
                <BibleVerse reference="1CO.15.51-55" text="1 Corinthians 15:51-55" />
                <BibleVerse reference="1TH.1.9-10" text="1 Thessalonians 1:9-10" />
                <BibleVerse reference="1TH.4.13-18" text="1 Thessalonians 4:13-18" />
                <BibleVerse reference="1TH.5.9-11" text="1 Thessalonians 5:9-11" />
                <BibleVerse reference="REV.3.10" text="Revelation 3:10" />
              </em>
            </li>
            <li>The Lord Jesus Christ will personally and visibly return to the earth with the saints to end the seven-year tribulation and to reign with the saints for 1000 years.
              <p><em>
                <BibleVerse reference="DAN.9.24-27" text="Daniel 9:24-27" />
                <BibleVerse reference="MAT.24.30-31" text="Matthew 24:30-31" />
                <BibleVerse reference="MAT.25.31-32" text="Matthew 25:31-32" />
                <BibleVerse reference="PHI.2.9-11" text="Philippians 2:9-11;" />
                <BibleVerse reference="REV.17.14" text="Revelation 17:14" />
                <BibleVerse reference="REV.19.11-21" text="Revelation 19:11-21" />
                <BibleVerse reference="REV.20.1-6" text="Revelation 20:1-6" />
                <br />
              </em></p>
            </li>
            <li>Satan will be released at the end of the millennium and will gather the armies of the nations against Jesus Christ and His saints, only to be defeated and cast into the lake of fire forever.
              <p><em>
                <BibleVerse reference="REV.20.7-10" text="Revelation 20:7-10" />
                <br />
              </em></p>
            </li>
            <li>All the unbelieving dead will then be raised to stand before the Great White Throne and be sentenced to their eternal punishment. Believers will forever enjoy God&#39;s presence, after He has created a new heaven and earth, where Christ will be King of kings and Lord of lords.
              <p><em>
                <BibleVerse reference="2PE.3.11-13" text="2 Peter 3:11-13" />
                <BibleVerse reference="REV.20.11-15" text="Revelation 20:11-15" />
                <BibleVerse reference="REV.21.1-8" text="Revelation 21:1-8" />
                <BibleVerse reference="REV.21.22-27" text="Revelation 21:22-27" />
                <BibleVerse reference="REV.22.1-5" text="Revelation 22:1-5" />
                <br />
              </em></p>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  )
}

export default WhatWeBelieveMore;
